export const formatSeatInfo = (information: any): string => {
  if (!information) return '';
  const parts = [information.area, information.seat_type, information.block, information.row, information.seat_number];
  return parts.filter(Boolean).join('・');
};

export const getSeatInformation = (item: any, seatDataMap?: Map<string, any>) => {
  if (!item?.order_table_number || !seatDataMap) return null;
  return seatDataMap.get(item.order_table_number) || null;
};

export default { formatSeatInfo, getSeatInformation };
